import axios from "axios";
import { CollaboratorModelNET } from "../../pages/collaborators/models/CollaboratorModelNET";
import { EmployeModel } from "../../pages/collaborators/models/EmployeModel";
import { CollaboratorAllResponse } from "app/types/collaborator";
const API_URL = process.env.REACT_APP_API_NET;
const codesToFilter: string[] = ["COLA_NOM", "COLA_PERF", "COLA_DEPTO"];

export async function getAllCollaborators(page: number | string, pageSize: number | string, filter: Object) {
  try {
    const filters = Object.entries(filter).filter(([_, value]) => value).map(([key, value]) => `&${key}=${value}`).join('');
    const response = await axios.get<CollaboratorAllResponse>(`${API_URL}Collaborator?page=${page}&pageSize=${pageSize}${filters}`);
    return response.data.data;
  } catch (error) {
    console.error("Error fetching collaborators:", error);
    throw error;
  }
}

export async function createCollaborator(body: CollaboratorModelNET) {
  let response;
  const { id, numberEmployed, name, paternalSurname, maternalSurname, phone, email, celullar, emergencyPhone,
    socialSecurity, institutionalEmail, curp, rfc, birthDate, birthCity, emergencyFullName,
    typePersonId, countryId, nationalityId, entityId, genderId, payrollPeriodId, typeCollaboratorId, photo, companyId, datePlant } = body;
  try {
    if (id) {
      response = await axios.put(`${API_URL}Collaborator/${id}`, {
        id,
        numberEmployed,
        typePersonId,
        name,
        photo,
        paternalSurname,
        maternalSurname,
        phone,
        celullar,
        email,
        countryId,
        nationalityId,
        entityId,
        genderId,
        curp,
        rfc,
        birthDate,
        birthCity,
        emergencyFullName,
        emergencyPhone,
        typeCollaboratorId,
        payrollPeriodId,
        companyId,
        institutionalEmail,
        socialSecurity,
        datePlant,
      });
      return response.data
    } else {
      response = await axios.post(`${API_URL}Collaborator`, {
        name,
        numberEmployed,
        paternalSurname,
        maternalSurname,
        photo,
        curp,
        celullar,
        phone,
        emergencyPhone,
        emergencyFullName,
        email,
        rfc,
        institutionalEmail,
        socialSecurity,
        birthDate,
        birthCity,
        typePersonId: 1,
        countryId,
        nationalityId,
        entityId,
        genderId,
        companyId: 1,
        typeCollaboratorId,
        payrollPeriodId: 1,
      });
      return response.data;
    }
  } catch (error) {
    console.error("Error creando el colaborador:", error);
    throw error; // Propagamos el error para manejarlo en el hook
  }
}

export async function uploadCollaboratorPhoto(id: number | string, photo: File, token: string) {

  const data = new FormData();
  data.append('file', photo);
  data.append('id', String(id));

  const config = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };

  return axios.put(`${API_URL}Collaborator/${id}/image-profile`, data, config);
}

export async function createEmploye(body: EmployeModel) {
  const { collaboratorId, profileId, departmentId, dateBegin, dateEnd, position, baseSalary } = body;
  try {
    const response = await axios.post(`${API_URL}Employe`, {
      collaboratorId,
      profileId,
      departmentId,
      dateBegin,
      dateEnd,
      position,
      baseSalary
    });

    return response.data;
  } catch (error) {
    console.error("Error creating collaborator:", error);
    throw error; // Propagamos el error para manejarlo en el hook
  }
}

// Llamada para obtener datos filtrados por un campo de colaborador
export async function getDataFilterBySelectFiledCollaborator(code: string) {
  let response;
  let data;

  try {
    switch (code) {
      case codesToFilter[0]: // Filtro por nombre
        response = await axios.post(`${API_URL}colaboradores/all`, {
          campo_id: null,
          valor: null,
        });
        data = response.data.doc.data.rows;
        break;

      case codesToFilter[1]: // Filtro por perfil
        response = await axios.get(`${API_URL}catalogs/PASOC?sort=name`);
        data = response.data.doc.data.rows;
        break;

      case codesToFilter[2]: // Filtro por departamento
        response = await axios.get(`${API_URL}catalogs/DEP?sort=name`);
        data = response.data.doc.data.rows;
        break;

      default:
        console.warn("Código de filtro no válido.");
        data = [];
        break;
    }
    return data;
  } catch (error) {
    console.error("Error fetching filtered data:", error);
    throw error;
  }
}

export async function handleCollaboratorStatus(collaboratorId: number, statusId: number) {
  switch (statusId) {
    case 3: //EN PROCESO
      return axios.put(`${API_URL}Collaborator/${collaboratorId}/high-request`);
    case 4: //GESTION DE ALTA
      return axios.put(`${API_URL}Collaborator/${collaboratorId}/high`);
    case 5: //TEMPORAL
      return axios.put(`${API_URL}Collaborator/${collaboratorId}/plant-request`);
    case 8: //GESTION DE PLANTA
      return axios.put(`${API_URL}Collaborator/${collaboratorId}/plant`);
    default:
      throw new Error('El cambio de status no es posible');
  }
};
